/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/DailyChallenges/TriPeaksChallenge',[
    'lodash',
    'absolute/stringmanager',
    'absolute/textutils',
    'CardUI/IChallengeDefinition',
    'SolitaireShared/CardLogic/ChallengeConstants',
    'SolitaireShared/CardLogic/Card',
    'SolitaireShared/TriPeaksLogic/ChallengeAuthorities/ClearBoardsDailyTripeaksAuthority',
    'SolitaireShared/TriPeaksLogic/ChallengeAuthorities/AchieveScoreDailyTripeaksAuthority',
    'SolitaireShared/TriPeaksLogic/ChallengeAuthorities/PlayCardDailyTripeaksAuthority',
    'SolitaireShared/TriPeaksLogic/ChallengeAuthorities/PlayValuesDailyTripeaksAuthority'
], function (_, _s, TextUtils, IChallengeDefinition, ChallengeConstants, Card, ClearBoardsDailyTripeaksAuthority, AchieveScoreDailyTripeaksAuthority, PlayCardDailyTripeaksAuthority, PlayValuesDailyTripeaksAuthority) {
    "use strict";


    var TriPeaksChallenge = function (challengeType, parameters, config) {
        this.initTriPeaksChallenge(challengeType, parameters, config);
    };

    var Key_MaxDeals = "MAXDEALS";

    TriPeaksChallenge.constructor = TriPeaksChallenge;
    TriPeaksChallenge.prototype = Object.create(IChallengeDefinition.prototype);


    TriPeaksChallenge.GoalType =
    {
        /// <summary>
        /// No Parameters
        /// </summary>
        ClearBoards: 0,

        /// <summary>
        /// PARAMETERS: ScoreRequired
        /// </summary>
        AchieveScore: 1,

        /// <summary>
        /// PARAMETERS: CardToPlay
        /// </summary>
        PlayCard: 2,

        /// <summary>
        /// PARAMETERS: NumToPlay, ValueToPlay
        /// </summary>
        PlayValues: 3
    };

    TriPeaksChallenge.prototype.GoalType = TriPeaksChallenge.GoalType;

    TriPeaksChallenge.prototype.initTriPeaksChallenge = function (challengeType, parameters, config) {
        IChallengeDefinition.call(this, challengeType, parameters, config);
    };

    TriPeaksChallenge.prototype.ConstructAuthority = function () {
        var authority = TriPeaksChallenge.AuthorityTypes[this.ChallengeType](this.Parameters);
        this.SetupOptionsForAuthority(authority);

        var maxDeals = parseInt(this.Parameters[Key_MaxDeals]);
        if (!isNaN(maxDeals) && maxDeals > 0) {
            authority.MaxDeals = maxDeals;
        }

        return authority;
    };

    TriPeaksChallenge.prototype.GetGoalDescription = function ()
    {
        try
        {
            var maxDeals = this.Parameters[Key_MaxDeals];
            switch (this.ChallengeType)
            {
                case TriPeaksChallenge.GoalType.ClearBoards:
                {
                    var paramValue = this.Parameters[ChallengeConstants.KeyBoardsToClear];
                    var paramConvered = parseInt(paramValue);

                    var result = paramValue;
                    if (!isNaN(paramConvered) && paramConvered > 0)
                    {
                        result = paramConvered.toString();
                    }
                    return _s(this.CompleteGoalLocString("DailyChallengeGoal_ClearBoards"),
                        [
                            result,
                            maxDeals,
                            this.GetTimeFormat(this.AllowedTime)
                        ]);

                }
            case TriPeaksChallenge.GoalType.AchieveScore:
                return _s(this.CompleteGoalLocString("DailyChallengeGoal_AchieveScore"),
                    [
                        TextUtils.formatInt(this.Parameters[ChallengeConstants.KeyScoreRequired]),
                        (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : maxDeals),
                        maxDeals
                    ]);
            case TriPeaksChallenge.GoalType.PlayValues:

                var value = Card.GetLongValueName(this.Parameters[PlayValuesDailyTripeaksAuthority.Key_ValueToPlay]);
                var numToPlay = parseInt(this.Parameters[PlayValuesDailyTripeaksAuthority.Key_NumToPlay]);


                var valueKey = "Card_" + value;
                if (!isNaN(numToPlay) && numToPlay > 1)
                {
                    if (value.toUpperCase() == "SIX")
                        valueKey += "es";
                    else
                        valueKey += "s";
                }
                value = _s(valueKey);

                return _s(this.CompleteGoalLocString("DailyChallengeGoal_ClearValuesFromBoard"),
                    [
                        numToPlay.toString(),
                        value,
                        maxDeals,
                        this.GetTimeFormat(this.AllowedTime)
                    ]);

            default:
                return "";
            }
        }
        catch (e) {
                return "";
        }
    };

    TriPeaksChallenge.prototype.GetChallengeIconUrl = function ()
    {
        return "Content/Icons/DailyChallenges/tripeaks.png"; // TODO
    };

    TriPeaksChallenge.prototype.GetModeName = function ()
    {
        return "TriPeaks"; // TODO return SolitaireGamesMap.Titles[SolitaireGameMode.TriPeaks];
    };

    TriPeaksChallenge.prototype.GetShortGoalDescription = function ()
    {
        switch (this.ChallengeType)
        {
        case TriPeaksChallenge.GoalType.ClearBoards:
            if(this.AllowedMoves > 0)
                return _s("Deals_Board_Challenge");

            if(this.AllowedTime > 0)
                return _s("Timed_Board_Challenge");

            return _s("Board_Challenge");

        case TriPeaksChallenge.GoalType.PlayCard:
        case TriPeaksChallenge.GoalType.PlayValues:
            if(this.AllowedMoves > 0)
                return _s("Moves_Card_Challenge");

            if(this.AllowedTime > 0)
                return _s("Timed_Card_Challenge");

            return _s("DCTile_Card_Challenge");

        case TriPeaksChallenge.GoalType.AchieveScore:
            if(this.AllowedMoves > 0)
                return _s("Moves_Score_Challenge");

            if(this.AllowedTime > 0)
                return _s("Timed_Score_Challenge");

            return _s("Score_Challenge");

        default:
            return "";
        }
    };

    TriPeaksChallenge.MakeClearBoardsAuthority = function (param) { return new ClearBoardsDailyTripeaksAuthority(param); };
    TriPeaksChallenge.MakeScoreAuthority = function (param) { return new AchieveScoreDailyTripeaksAuthority(param); };
    TriPeaksChallenge.MakePlayCardAuthority = function (param) { return new PlayCardDailyTripeaksAuthority(param); };
    TriPeaksChallenge.MakePlayValuesAuthority = function (param) { return new PlayValuesDailyTripeaksAuthority(param); };

    // note: the following relies on being indexed by GoalType values above
    TriPeaksChallenge.AuthorityTypes = [
        TriPeaksChallenge.MakeClearBoardsAuthority,
        TriPeaksChallenge.MakeScoreAuthority,
        TriPeaksChallenge.MakePlayCardAuthority,
        TriPeaksChallenge.MakePlayValuesAuthority
    ];


    TriPeaksChallenge.FromDictionary = function (spec)
    {
        var retval = null;
        var challengeType = parseInt(spec.Data["CHDEF_ChallengeType"]);
        var parameters = {};

        _.forEach(spec.Data, function (value, key) {
            if (key.indexOf("PARAM_") == 0) {
                var nkey = key.substring(6);
                parameters[nkey] = value;
            }
        });

        retval = new TriPeaksChallenge(challengeType, parameters, spec);
        retval.FromDictionaryInternal(spec.Data);

        return retval;
    };

    TriPeaksChallenge.FirstParameters =
    {
        "ClearBoards": "BoardsToClear",
        "AchieveScore": "ScoreRequired",
        "PlayCard": "CardToPlay",
        "PlayValues": "NumberToPlay"
    };

    TriPeaksChallenge.SecondParameters =
    {
        "ClearBoards": null,
        "AchieveScore": null,
        "PlayCard": null,
        "PlayValues": "ValueToPlay"
    };

    TriPeaksChallenge.prototype.CompleteGoalLocString = function (str)
    {
        var ret = str;

        var maxDeals = parseInt(this.Parameters[Key_MaxDeals]);

        if (this.AllowedTime > 0)
            ret += "_Time";
        if (!isNaN(maxDeals) && maxDeals > 0 && this.ChallengeType != TriPeaksChallenge.GoalType.AchieveScore)
        ret += "_Moves";

        var numToPlay = 0;
        var param = this.Parameters[PlayValuesDailyTripeaksAuthority.Key_NumToPlay];
        numToPlay = parseInt(param);


        if (!isNaN(numToPlay) && numToPlay > 1)
        {
            ret += "_Multiple";
        }

        return ret;
    };

    return TriPeaksChallenge;

});

